import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import {EmailMakerBlockManager} from '@Components/email-maker-block-manager/email-maker-block-manager';
import type {EmailMakerBlockManagerProps} from '@Components/email-maker-block-manager/email-maker-block-manager';

window.PMW.mergePMW(PMW, {
  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {grapesjs.Editor} [opts.gjsEditor]
   */
  renderEmailMakerBlockManager(containerElement: HTMLElement, opts: EmailMakerBlockManagerProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerBlockManager {...opts} />
      </Provider>
    );
  },
});
